import { Alert, Box } from '@mui/material';
import Loading from '@components/shared/Loading';
import { Summary } from './Summary';
import {
  useCurrentReport,
  useCurrentReports,
} from '@features/campaigns/subdomains/visitation/hooks/useReports';
import { useCurrentCampaign } from '@features/campaigns/subdomains/visitation/hooks';
import { SalesDataRefreshed } from '../SalesDataRefreshed';
import { useFeatures } from '@utils/hooks';

export const SummaryContainer = () => {
  const { campaign, isFetching: campaignLoading } = useCurrentCampaign();
  const { reports, loading: allReportsLoading } = useCurrentReports();
  const { report, salesReport, loading: reportLoading } = useCurrentReport();
  const { salesDataRefreshedDateHidden } = useFeatures();

  if (campaignLoading || allReportsLoading || reportLoading) return <Loading />;

  if (!campaign || !report || !reports?.length)
    return <Alert severity="error">Error loading campaign data.</Alert>;

  return (
    <>
      {salesReport && !salesDataRefreshedDateHidden ? (
        <Box paddingBottom="1rem">
          <SalesDataRefreshed reportDate={new Date(salesReport.reportDate)} />
        </Box>
      ) : null}
      <Summary
        allReports={reports}
        selectedReport={report}
        campaign={campaign}
        latestSalesReport={salesReport}
      />
    </>
  );
};
